import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'static/css/AlternateAuthModal.css'
import { InputTel, InputEmail } from '@yapay/design-system'
import ClickToPayToolTip from 'components/ClickToPayToolTip'

const AlternateAuthModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  errorMessage: externalErrorMessage,
}) => {
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [internalErrorMessage, setInternalErrorMessage] = useState('')
  const [showTooltip, setShowTooltip] = useState(false)

  const errorMessage = externalErrorMessage || internalErrorMessage
  const isFormValid = email.trim() || phone.trim()
  const isSubmitDisabled = loading || !isFormValid

  const handleInputChange = (setter, value) => {
    setter(value)
    setInternalErrorMessage('')
  }

  const handleSubmit = event => {
    event.preventDefault()
    event.stopPropagation()

    if (!isFormValid) {
      setInternalErrorMessage(
        'Por favor, insira um email ou número de telefone.',
      )
      return
    }

    onSubmit(phone.trim() || null, email.trim() || null)
  }

  const handleClose = () => {
    setEmail('')
    setPhone('')
    setInternalErrorMessage('')
    onClose()
  }

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) handleClose()
  }

  if (!isOpen) return null

  return (
    <div
      className="alternate-auth-modal-backdrop"
      onClick={handleBackdropClick}
    >
      <div
        className="alternate-auth-modal-content"
        onClick={e => e.stopPropagation()}
      >
        <form className="alternate-auth-modal-form" onSubmit={handleSubmit}>
          <div className="alternate-auth-modal-header">
            <h2 className="alternate-auth-modal-title">
              Acesse seu Click to Pay
            </h2>
            <button
              type="button"
              className="alternate-auth-modal-close-button"
              onClick={handleClose}
            >
              ×
            </button>
          </div>

          <div className="w-full">
            <InputEmail
              label="E-mail"
              id="email"
              name="email"
              value={email}
              onChange={e => handleInputChange(setEmail, e.target.value)}
            />
          </div>

          <div className="w-full">
            <InputTel
              label="Telefone"
              name="phone"
              id="phone"
              value={phone}
              onChange={e => handleInputChange(setPhone, e.target.value)}
            />
          </div>

          {errorMessage && (
            <div className="alternate-auth-modal-error">{errorMessage}</div>
          )}

          <div className="alternate-auth-modal-info-wrapper">
            <p className="alternate-auth-modal-info-text">
              Como o{' '}
              <span className="click-to-pay-info__trigger">
                <button
                  type="button"
                  className="alternate-auth-modal-info-button"
                  onClick={() => setShowTooltip(true)}
                >
                  Click to Pay
                </button>
                <ClickToPayToolTip
                  show={showTooltip}
                  onClose={() => setShowTooltip(false)}
                />
              </span>{' '}
              usa minhas informações?
            </p>
          </div>

          <div className="alternate-auth-modal-buttons">
            <button
              type="button"
              className="alternate-auth-modal-cancel-button"
              onClick={handleClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="alternate-auth-modal-submit-button"
              disabled={isSubmitDisabled}
            >
              {loading ? 'Processando...' : 'Entrar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

AlternateAuthModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
}

AlternateAuthModal.defaultProps = {
  loading: false,
  errorMessage: '',
}

export default AlternateAuthModal
